import { Flex } from '@chakra-ui/react';
import React from 'react';
import { FilterHeading } from 'src/components/atoms/FilterHeading';
import { MenuOpenerButton } from 'src/components/atoms/MenuOpenerButton';
import { ClearFiltersButton } from 'src/components/molecules/ClearFiltersButton';
import { FilterAccordion } from 'src/components/molecules/FilterAccordion';
import { LockFiltersButton } from 'src/components/molecules/LockFiltersButton';
import { MediaMenu } from 'src/components/organisms/menus/MediaMenu';
import { TimeRangeSelector } from 'src/components/organisms/TimeRangeSelector';

export const LTFilterBar: React.FC = () => {
  return (
    <FilterAccordion>
      <Flex w="100%" alignItems="center" wrap="wrap">
        {/* Time Range */}
        <Flex direction="column" mr={3} my={2}>
          <FilterHeading headingText="Time Range" color="content.label" />
          <TimeRangeSelector
            includeTimePeriodButtons
            rightElement={<LockFiltersButton filterType="time range" />}
          />
        </Flex>

        {/* Media */}
        <Flex direction="column" alignItems="flex-start" mr={3} my={2}>
          <FilterHeading headingText="Media" color="content.label" />
          <MenuOpenerButton>
            <MediaMenu />
            <LockFiltersButton filterType="media" />
          </MenuOpenerButton>
        </Flex>
      </Flex>

      {/* Clear Filters */}
      <ClearFiltersButton />
    </FilterAccordion>
  );
};
